<template>
  <div>
    <template>
      <v-container>
        <v-row>
          <v-col cols="12">
            <Subheader icon="mdi-card-text" title="Allgemein"></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col v-if="mode === 'new'" cols="12" sm="6" md="6">
                        <v-autocomplete
                          v-model="performanceTargetExceptionLocal.user"
                          :items="membershipsList"
                          label="Person auswählen"
                          :rules="[rules.required]"
                          outlined
                          small-chips
                          return-object
                          hide-details="auto"
                          item-text="displayName"
                          item-value="uid"
                          :search-input.sync="memberSearch"
                        >
                          <template v-slot:item="{ item }">
                            <v-avatar color="secondary" size="38">
                              <span class="white--text">{{
                                initials(item.displayName)
                              }}</span>
                            </v-avatar>
                            <v-list-item-content class="ml-4">
                              <v-list-item-title>{{
                                item.displayName
                              }}</v-list-item-title>
                              <v-list-item-subtitle v-if="item.groupTitle">{{
                                item.groupTitle
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col v-else cols="12" md="6">
                        <v-text-field
                          :value="
                            performanceTargetExceptionLocal.user.displayName
                          "
                          label="Mitglied"
                          outlined
                          readonly
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model.trim="performanceTargetExceptionLocal.reason"
                          clearable
                          label="Grund"
                          :rules="[rules.required]"
                          hide-details="auto"
                          outlined
                        ></v-text-field
                      ></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader icon="mdi-cog" title="Einstellungen"></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <div class="mb-4">Gültig ab:</div>
                        <v-text-field
                          v-model="
                            performanceTargetExceptionLocal.validFrom.date
                          "
                          type="date"
                          label="Startdatum"
                          hint="DD.MM.YYYY"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          required
                          prepend-inner-icon="mdi-calendar-start"
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="
                            performanceTargetExceptionLocal.validFrom.time
                          "
                          label="Startzeit"
                          hint="HH:MM"
                          :rules="[rules.required, rules.startBeforeEnd]"
                          outlined
                          type="time"
                          prepend-inner-icon="mdi-clock-start"
                        ></v-text-field>
                      </v-col>
                    </v-row> -->

                      <!-- <v-row> -->
                      <v-col cols="12" sm="6" md="4">
                        <div class="mb-4">Gültig bis:</div>
                        <v-text-field
                          v-model="
                            performanceTargetExceptionLocal.validUntil.date
                          "
                          type="date"
                          label="Enddatum"
                          hint="DD.MM.YYYY"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          required
                          prepend-inner-icon="mdi-calendar-end"
                        ></v-text-field>
                      </v-col>
                      <!-- <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="
                            performanceTargetExceptionLocal.validUntil.time
                          "
                          label="Endzeit"
                          hint="HH:MM"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          type="time"
                          prepend-inner-icon="mdi-clock-end"
                        ></v-text-field>
                      </v-col> -->
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <div class="mb-4">Anwendbar auf:</div>
                        <v-select
                          v-model="
                            performanceTargetExceptionLocal
                              .applicablePerformanceTargets.data
                          "
                          :items="performanceTargetsFiltered"
                          label="Zielvorgaben"
                          outlined
                          multiple
                          return-object
                          small-chips
                          hide-details="auto"
                          :rules="[rules.required]"
                          item-value="id"
                          item-text="title"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import { MEMBER_MANAGEMENT, ADMIN } from "@/store/modules.js";
import {
  GET_PERFORMANCE_TARGETS,
  GET_USER_LIST,
} from "@/store/action-types.js";
export default {
  name: "performance-target-exception-editor",
  props: {
    performanceTargetException: {},
    mode: {
      type: String,
      default: "new",
      required: true,
      validator: function (value) {
        return ["new", "edit"].indexOf(value) !== -1;
      },
    },
  },
  components: {
    Subheader,
  },
  data() {
    return {
      memberSearch: null,
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
    };
  },
  model: {
    prop: "performanceTargetException",
    event: "performanceTargetExceptionChange",
  },
  computed: {
    performanceTargetExceptionLocal: {
      get: function () {
        return this.performanceTargetException;
      },
      set: function (value) {
        this.$emit("performanceTargetExceptionChange", value);
      },
    },
    performanceTargets() {
      return this.$store.state.memberManagement.performanceTargets;
    },
    performanceTargetsFiltered() {
      return this.performanceTargets.map((target) => ({
        id: target.meta.id,
        title: target.title,
        shortTitle: target.shortTitle,
        sortKey: target.sortKey,
      }));
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic.filter(
        (membership) => membership.access.type === "member"
      );
    },
    membershipsList() {
      const input = this.memberships;

      // Sort memberships by division sortKey first
      const sortedInput = [...input].sort((a, b) => {
        const aSortKey = a.user.division ? a.user.division.sortKey : 9999;
        const bSortKey = b.user.division ? b.user.division.sortKey : 9999;
        return aSortKey - bSortKey;
      });

      // Group memberships by division title
      const groupItems = (arr) => {
        return arr.reduce((a, c) => {
          const groupTitle = c.user.division
            ? c.user.division.title
            : "Ohne Gruppe";
          if (typeof a[groupTitle] === "undefined") a[groupTitle] = [];
          a[groupTitle] = [...a[groupTitle], c];
          return a;
        }, {});
      };

      const step1 = groupItems(sortedInput);

      // Insert headers and dividers
      const insertHeaders = (obj) => {
        return Object.entries(obj).reduce((a, [key, vals], i, d) => {
          let r = [
            {
              header: key,
            },
            ...vals,
          ];
          // Add divider between groups (but not after the last one)
          if (i < d.length - 1) {
            r = [
              ...r,
              {
                divider: true,
              },
            ];
          }
          a = [...a, ...r];
          return a;
        }, []);
      };

      const step2 = insertHeaders(step1);

      // Map to final structure
      const step3 = step2
        .filter(
          (item) =>
            item.header ||
            item.divider ||
            (item.user && item.user.displayName && item.user.uid)
        )
        .map((item) => {
          if (item.header || item.divider) {
            // Keep headers and dividers as-is
            return item;
          } else if (item.user && item.user.displayName && item.user.uid) {
            // Extract user details from membership object
            return {
              uid: item.user.uid,
              membershipId: item.user.membershipId,
              displayName: item.user.displayName,
              firstName: item.user.firstName,
              lastName: item.user.lastName,
              groupTitle: item.group ? item.group.title : null,
            };
          } else {
            return {
              displayName: "",
              uid: "",
            };
          }
        });

      return step3;
    },
  },
  watch: {
    "performanceTargetExceptionLocal.user": {
      handler(newUser) {
        if (newUser && this.mode === "new" && newUser.uid) {
          // User object is already in correct format from membershipsList
          // No need to transform
        }
      },
      deep: true,
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_PERFORMANCE_TARGETS}`, {
        organizationId: this.$route.params.organizationId,
      });

      this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
        organizationId: this.$route.params.organizationId,
        queryIsFiltered: true,
        query: {
          type: "active",
        },
      });
    },
    initials(name) {
      if (!name) return "";
      return name
        .split(" ")
        .map((part) => part[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);
    },
  },
};
</script>
